import { ToastContainer as ToastContainer$1, Slide } from 'react-toastify';
import { jsx } from 'react/jsx-runtime';

var ToastContainer = function ToastContainer(_ref) {
  var _ref$rtl = _ref.rtl,
      rtl = _ref$rtl === void 0 ? false : _ref$rtl,
      _ref$autoClose = _ref.autoClose,
      autoClose = _ref$autoClose === void 0 ? 3000 : _ref$autoClose,
      _ref$pauseOnHover = _ref.pauseOnHover,
      pauseOnHover = _ref$pauseOnHover === void 0 ? false : _ref$pauseOnHover;
  return /*#__PURE__*/jsx(ToastContainer$1, {
    autoClose: autoClose,
    closeOnClick: false,
    draggable: false,
    hideProgressBar: true,
    newestOnTop: true,
    pauseOnHover: pauseOnHover,
    pauseOnFocusLoss: false,
    position: rtl ? "top-left" : "top-right",
    rtl: rtl,
    transition: Slide
  });
};

export { ToastContainer as default };
//# sourceMappingURL=toast-container-esm.js.map
